// extracted by mini-css-extract-plugin
export default {"infoMark":"OrgAccountsTab_infoMark__HNUcJ"};